<template>
  <div class="layout" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div style="position: fixed; left: 60px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <el-row style="padding: 15px; padding-left: 30px; min-width: 900px; max-width: 1500px; margin: 0 auto;">
      <el-col :sm="24" :md="11" style="margin-bottom: 20px;">
        <div style="text-align: left; padding-right: 0; max-width: 1200px; margin: 0 auto;">
          <el-row :gutter="20">
            <el-col :sm="12" :md="24">
              <div class="totalNum">
                <div style="padding: 15px;">
                  <el-radio-group v-model="selectedData" fill="#777">
                    <el-radio-button label="已註冊會員人數"></el-radio-button>
                    <el-radio-button label="推薦會員數" :disabled="!haveRecom"></el-radio-button>
                  </el-radio-group>
                </div>
                <div style="padding: 15px;">
                  <el-date-picker style="width: 150px"
                    size="small"
                    v-model="value2"
                    align="right"
                    type="date"
                    placeholder="依日期查詢"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                  <div style="margin-top: 15px; font-size: 17px;" v-if="selectedData === '已註冊會員人數'">當日加入會員: <span style="color: #f24; font-weight: 500; font-size: 20px;">{{ getNum(AllMemberData) }}</span></div>
                  <div style="margin-top: 15px; font-size: 17px;" v-if="selectedData === '推薦會員數'">當日推薦會員: <span style="color: #f24; font-weight: 500; font-size: 20px;">{{ getNum2(AllMemberData) }}</span></div>
                </div>
                <div class="number" v-if="selectedData === '已註冊會員人數'"><span style="font-size: 75px; color: #00c300; margin-right: 10px;">{{ num }}</span><mu-icon value="person" class="icon"></mu-icon></div>
                <div class="number" v-if="selectedData === '推薦會員數'"><span style="font-size: 75px; color: #00c300; margin-right: 10px;">{{ recomNum }}</span><mu-icon value="person" class="icon"></mu-icon></div>
              </div>
            </el-col>
            <el-col :sm="12" :md="24" v-if="selectedData === '已註冊會員人數'">
              <div class="analysis">
                <div style="margin-left: 15px; margin-top: 15px; padding: 3px 10px; border-radius: 3px; font-size: 15px; background-color: #2c3e50; display: inline-block; color: #fff; font-weight: 500;">最近一週</div>
                <ve-line :data="chartData" :y-axis="yaxis" style="transform: scale(0.95);"></ve-line>
              </div>
            </el-col>
            <el-col :sm="12" :md="24" v-if="selectedData === '推薦會員數'">
              <div class="analysis">
                <div style="margin-left: 15px; margin-top: 15px; padding: 3px 10px; border-radius: 3px; font-size: 15px; background-color: #2c3e50; display: inline-block; color: #fff; font-weight: 500;">最近一週</div>
                <ve-line :data="chartData2" :y-axis="yaxis" style="transform: scale(0.95);"></ve-line>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :sm="24" :md="13">
        <div class="member">
          <div style="text-align: left; margin-bottom: 10px;">
            <el-radio-group v-model="radio1">
              <el-radio-button label="會員列表"></el-radio-button>
              <el-radio-button label="禮物碼兌換紀錄"></el-radio-button>
            </el-radio-group>
          </div>
          <iframe v-if="isSheet && radio1 === '會員列表'" :src="sheetUrl" frameborder="0" width="100%" style="border: 1px solid #eee;" height="353"></iframe>
          <iframe v-if="isGift && radio1 === '禮物碼兌換紀錄'" :src="giftUrl" frameborder="0" width="100%" style="border: 1px solid #eee;" height="353"></iframe>
          <div style="text-align: right;">ctl+F 可以使用關鍵字搜尋</div>
        </div>
        <div class="member" style="margin-top: 15px;">
          <div style="text-align: left; font-weight: 500; font-size: 18px;">會員備註欄</div>
          <el-row style="margin-top: 15px;" :gutter="10">
            <el-col :span="14">
              <el-input v-model="phone" style="width: 100%;" placeholder="請輸入用戶電話"></el-input>
            </el-col>
            <el-col :span="5">
              <el-button :loading="isLoading" icon="el-icon-search" type="primary" style="width: 90%;" @click="getUserComment">查詢</el-button>
            </el-col>
          </el-row>
          <div style="margin-top: 10px; margin-bottom: 10px;">
            <el-input type="textarea"
              :rows="2"
              placeholder="請輸入備註內容"
              v-model="comment">
            </el-input>
          </div>
          <el-button style="width: 100%;" type="danger" @click="addComment">新增</el-button>
        </div>
      </el-col>
    </el-row>
    <div style="text-align: left; padding-left: 20px; margin-bottom: 20px;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VeLine from 'v-charts/lib/line.common'
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      sheetUrl: '',
      giftUrl: '',
      service: this.$route.params.service,
      auth: this.$route.params.id,
      phone: '',
      radio1: '會員列表',
      selectedData: '已註冊會員人數',
      isGift: false,
      isSheet: false,
      isLoading: false,
      haveRecom: true,
      pageLoading: false,
      comment: '',
      num: 0,
      recomNum: 0,
      AllMemberData: {},
      totalMember: 0,
      date: '所有',
      value2: '',
      yaxis: {
        min: 10
      },
      chartExtend: {
        series: {
          rotationRange: [0, 0],
          sizeRange: [50, 150],
          width: '100%',
          height: '100%',
          drawOutOfBound: true,
          textStyle: {
            normal: {
              color: function () {
                return 'rgb(' + [
                  Math.round(Math.random() * 160),
                  Math.round(Math.random() * 160),
                  Math.round(Math.random() * 160)
                ].join(',') + ')'
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowColor: '#888'
            }
          }
        }
      },
      chartData2: {
        columns: ['date', '人數'],
        rows: [
          { 'date': '01-01', '人數': 0 },
          { 'date': '01-02', '人數': 0 },
          { 'date': '01-03', '人數': 0 },
          { 'date': '01-04', '人數': 0 },
          { 'date': '01-05', '人數': 0 },
          { 'date': '01-06', '人數': 0 },
          { 'date': '01-07', '人數': 0 },
        ]
      },
      chartData: {
        columns: ['date', '人數'],
        rows: [
          { 'date': '01-01', '人數': 0 },
          { 'date': '01-02', '人數': 0 },
          { 'date': '01-03', '人數': 0 },
          { 'date': '01-04', '人數': 0 },
          { 'date': '01-05', '人數': 0 },
          { 'date': '01-06', '人數': 0 },
          { 'date': '01-07', '人數': 0 },
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
    };
  },
  mounted() {
    // get('recomExp').then((_list) => {
    //   const _idList = _list.map(el => el.id.toString());
    //   if (_idList.indexOf(this.auth) !== -1) {
    //     this.haveRecom = true;
    //   }
    // })
    this.getSheet();
    this.getMemberData();
  },
  components: {
    VeLine
  },
  methods: {
    ...mapActions({
      addUserComment: 'addUserComment',
      getMemberCount: 'getMemberCount',
      getSheetUrl: 'getSheetUrl',
      getPoints: 'getPoints'
    }),
    getNum2(data) {
      if (this.value2 === '') {
        return 0;
      } else {
        const year = new Date(this.value2).getFullYear();
        const month = new Date(this.value2).getMonth() + 1;
        const date = new Date(this.value2).getDate();
        if (this.value2) {
          if (data['recom'][year][month][date]) {
            return data['recom'][year][month][date];
          }
          else {
            return 0;
          }
        }
      }
    },
    getNum(data) {
      if (this.value2 === '') {
        return 0;
      } else {
        const year = new Date(this.value2).getFullYear();
        const month = new Date(this.value2).getMonth() + 1;
        const date = new Date(this.value2).getDate();
        if (this.value2) {
          if (data[year][month][date]) {
            return data[year][month][date];
          }
          else {
            return 0;
          }
        }
      }
    },
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    getTime() {
      if (this.value2 === '' ) {
        return '所有';
      }
      return new Date(this.value2).toLocaleDateString() + ' ';
    },
    getSheet() {
      this.getSheetUrl({ service: this.service, auth: this.auth })
        .then((res) => {
          if (res.data.Url) {
            this.isSheet = true;
            this.sheetUrl = `https://docs.google.com/spreadsheets/d/e/${res.data.Url}/pubhtml?gid=0&single=true&widget=false&headers=false&chrome=false`;
          }
          if (res.data.Gift) {
            this.isGift = true;
            this.giftUrl = `https://docs.google.com/spreadsheets/d/e/${res.data.Gift}/pubhtml?gid=0&single=true&widget=false&headers=false&chrome=false`;
          }
        })
    },
    getUserComment() {
      this.isLoading = true;
      this.getPoints({ service: this.service, auth: this.auth, phone: this.phone })
        .then((res) => {
          this.comment = res.Comment
          this.isLoading = false;
        });
    },
    addComment() {
      this.pageLoading = true;
      this.addUserComment({ service: this.service, auth: this.auth, phone: this.phone, comment: this.comment })
        .then(() => {
          this.pageLoading = false;
          this.$notify({
            title: '已新增備註',
            type: 'success'
          });
        })
    },
    insertChartData(res) {
      // 圖表
      const nowYear = new Date().getFullYear();
      const nowMonth = new Date().getMonth() + 1;
      const nowDay = new Date().getDate();
      const lastMonthDay = nowMonth !== 1 ? new Date(nowYear, nowMonth - 1, 0).getDate() : new Date(nowYear - 1, 12, 0).getDate();
      let numList = [];
      let numList2 = [];
      // 全部人數
      for (let i = 0; i < 7; i += 1) {
        if (nowDay - i > 0) {
          numList[i] = {
            'date': `${nowMonth < 10 ? '0' + nowMonth : nowMonth}-${nowDay - i < 10 ? '0' + (nowDay - i).toString() : nowDay - i}`,
            '人數': (res.data.Data[nowYear] && res.data.Data[nowYear][nowMonth] && res.data.Data[nowYear][nowMonth][nowDay - i]) ? res.data.Data[nowYear][nowMonth][nowDay - i] : 0
          };
        }
        else {
          if (nowMonth === 1) {
            const number = (nowDay - i) * -1;
            numList[i] = {
              'date': `12-${lastMonthDay - number}`,
              '人數': (res.data.Data[nowYear - 1] && res.data.Data[nowYear - 1][12] && res.data.Data[nowYear - 1][12][lastMonthDay - number]) ? res.data.Data[nowYear - 1][12][lastMonthDay - number] : 0
            }
          }
          else {
            const number = (nowDay - i) * -1;
            numList[i] = {
              'date': `${nowMonth - 1 < 10 ? '0' + (nowMonth - 1).toString() : nowMonth - 1}-${lastMonthDay - number}`,
              '人數': (res.data.Data[nowYear] && res.data.Data[nowYear][nowMonth - 1] && res.data.Data[nowYear][nowMonth - 1][lastMonthDay - number]) ? res.data.Data[nowYear][nowMonth - 1][lastMonthDay - number] : 0
            };    
          }
        }
      }
      if (res.data.Data.recom) {
        this.recomNum = res.data.Data.recom.all;
        // 全部人數
        for (let i = 0; i < 7; i += 1) {
          if (nowDay - i > 0) {
            numList2[i] = {
              'date': `${nowMonth < 10 ? '0' + nowMonth : nowMonth}-${nowDay - i < 10 ? '0' + (nowDay - i).toString() : nowDay - i}`,
              '人數': (res.data.Data.recom[nowYear] && res.data.Data.recom[nowYear][nowMonth] && res.data.Data.recom[nowYear][nowMonth][nowDay - i]) ? res.data.Data.recom[nowYear][nowMonth][nowDay - i] : 0
            };
          }
          else {
            if (nowMonth === 1) {
              const number = (nowDay - i) * -1;
              numList2[i] = {
                'date': `12-${lastMonthDay - number}`,
                '人數': (res.data.Data.recom[nowYear - 1] && res.data.Data.recom[nowYear - 1][12] && res.data.Data.recom[nowYear - 1][12][lastMonthDay - number]) ? res.data.Data.recom[nowYear - 1][12][lastMonthDay - number] : 0
              }
            }
            else {
              const number = (nowDay - i) * -1;
              numList2[i] = {
                'date': `${nowMonth - 1 < 10 ? '0' + (nowMonth - 1).toString() : nowMonth - 1}-${lastMonthDay - number}`,
                '人數': (res.data.Data.recom[nowYear] && res.data.Data.recom[nowYear][nowMonth - 1] && res.data.Data.recom[nowYear][nowMonth - 1][lastMonthDay - number]) ? res.data.Data.recom[nowYear][nowMonth - 1][lastMonthDay - number] : 0
              };
            }
          }
        }
        this.chartData2.rows = numList2.reverse();
      }
      this.chartData.rows = numList.reverse();
    },
    getMemberData() {
      this.pageLoading = true;
      this.getMemberCount({ service: this.service, auth: this.auth })
        .then((res) => {
          this.pageLoading = false;
          const memberData = res.data.Data;
          if (memberData) {
            this.AllMemberData = memberData;
            this.num = memberData.total;
            this.insertChartData(res);
          }
        })
    }
  }
}
</script>

<style scoped>
#top-bar {
  display: none !important;
}
.layout {
  min-width: 100%;
  max-width: 100%;
  padding-top: 80px;
  margin-left: 0!important;
  flex: 1 1 100%;
}
.layout-66 {
  border-radius: 6px;
  background: #ffffff;
  height: 500px;
  min-width: 66.6666%;
  max-width: 66.6666%;
  flex: 0 1 66.6666%;
}
.card {
  border-radius: 3px;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
.layout-33 {
  height: 500px;
  background: #ffffff;
  min-width: 100px;
  max-width: 400px;
  flex: 0 1 33.3333%;
}
.title2 {
  background-color: #666;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
}
.member {
  text-align: center;
  padding: 15px;
  display: inline-block;
  width: 95%;
  max-width: 777px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.totalNum {
  height: 280px;
  margin-bottom: 20px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
  position: relative;
}
.analysis {
  height: 400px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.icon {
  transform: translateY(6px);
  font-size: 35px;
  margin-right: 5px;
}
.number {
  position: absolute;
  right: 45px;
  bottom: 20px;
  color: #888;
}
</style>